document.addEventListener("DOMContentLoaded", () => {
    $('#shopify-section-announcement-bar').slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: true,
        nextArrow: $('.announcement-next'),
        prevArrow: $('.announcement-prev'),
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1000,
                settings: "unslick"
            }
        ]
    })
})